<!-- eslint-disable vue/no-v-html -->
<script>
export default {
    name: 'Weekly',

    props: {
        viewSelectorHeight: {
            type: Number,
            required: true
        },
        zenHeaderHeight: {
            type: Number,
            required: true
        },
        dataSet: {
            type: Object,
            required: true
        },
        calendar: {
            type: Object,
            required: true
        }
    }
}
</script>

<template>
    <div>
        <div
            class="container-fluid"
            :style="{
                position: 'sticky',
                top: zenHeaderHeight+viewSelectorHeight+'px',
                backgroundColor: 'white',
                zIndex: 41
            }"
        >
            <div class="container">
                <weekly-nav
                    :data-set="dataSet"
                    v-on="$listeners"
                />
            </div>
        </div>
        <div class="container-fluid">
            <div class="container">
                <div
                    v-for="(day, idx) in calendar.getOccasionsForWeek(dataSet.navWeekStart)"
                    :key="idx"
                >
                    <div :class="{ 'mt-3 bt' : idx }">
                        <div class="row pt-4">
                            <div
                                class="col-12 col-sm-3 text-selection-none d-sm-block d-flex align-items-end"
                                :class="day.occasions.length ? 'justify-content-between' : 'justify-content-start'"
                            >
                                <div>
                                    <div class="text-uppercase dayname">
                                        {{ dateFormatDayname(day.date) }}
                                    </div>
                                    <div class="daynumber pb-3 pb-sm-0">
                                        <span
                                            class="day-number-circle"
                                            @click="$emit('go-to-day', day.date)"
                                        >
                                            {{ dateFormatDaynumber(day.date) }}
                                        </span>
                                    </div>
                                </div>
                                <!-- MOBILE BELOW -->
                                <div
                                    v-if="day.occasions.length"
                                    class="d-block d-sm-none pb-3 occasions-count"
                                    v-html="__('Events in total: <strong>:count</strong>', { count: day.occasions.length })"
                                />
                                <div
                                    v-else
                                    class="d-block d-sm-none align-self-end pb-3 pl-3 no-occasions"
                                >
                                    {{ __('No programs available') }}
                                </div>
                            </div>
                            <div class="col-12 col-sm-9">
                                <div class="row-on-desktop h-100">
                                    <div
                                        v-if="!day.occasions.length"
                                        class="d-none d-sm-block my-auto no-occasions"
                                    >
                                        {{ __('No programs available') }}
                                    </div>
                                    <div
                                        v-for="(occasion, idxo) in day.occasions"
                                        :key="idxo"
                                        class="col-9 col-md-4 mr-3 mr-sm-0 pb-3"
                                    >
                                        <!-- DESKTOP BELOW -->
                                        <div class="d-none d-sm-block h-100">
                                            <event-item-preview
                                                :occasion="occasion"
                                                weekly-view
                                                reveal-on-hover
                                            />
                                        </div>

                                        <!-- MOBILE BELOW -->
                                        <div class="d-block d-sm-none h-100">
                                            <event-item :occasion="occasion" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <weekly-nav
                            bottom-nav
                            :data-set="dataSet"
                            v-on="$listeners"
                        /> -->
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
::v-deep .v-popper {
    width: 100% !important;
}
</style>
